'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _createColorPalette=require('./createColorPalette'),_createColorPalette2=_interopRequireDefault(_createColorPalette);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var ninja={9:'#40404c',10:'#2f2f39',11:'#1b1b26'};exports.default=(0,_createColorPalette2.default)(ninja,'ninja');


/** WEBPACK FOOTER **
 ** ./~/@vitalsource/vstui/colors/ninja.js
 **/